<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { generateToken } from 'src/modules/recaptcha_v3_module.js';

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      fields: {
        pIva: '',
        company: '',
        province: '',
        telephone: '',
      },
      source: '',
      productName: globalState.pageModel.name_to_content[globalState.pageModel.main_content_name].product_name,
      error: null,
      success: false,
      provinces: [{ id: 12, name: "Agrigento" }, { id: 5, name: "Alessandria" }, { id: 1, name: "Ancona" }, { id: 77, name: "Aosta" }, { id: 48, name: "Arezzo" }, { id: 4, name: "Ascoli Piceno" }, { id: 6, name: "Asti" }, { id: 34, name: "Avellino" }, { id: 29, name: "Bari" }, { id: 111, name: "Barletta Andria Trani" }, { id: 66, name: "Belluno" }, { id: 35, name: "Benevento" }, { id: 90, name: "Bergamo" }, { id: 7, name: "Biella" }, { id: 57, name: "Bologna" }, { id: 102, name: "Bolzano" }, { id: 91, name: "Brescia" }, { id: 30, name: "Brindisi" }, { id: 78, name: "Cagliari" }, { id: 13, name: "Caltanissetta" }, { id: 87, name: "Campobasso" }, { id: 105, name: "Carbonia Iglesias" }, { id: 36, name: "Caserta" }, { id: 14, name: "Catania" }, { id: 21, name: "Catanzaro" }, { id: 44, name: "Chieti" }, { id: 92, name: "Como" }, { id: 22, name: "Cosenza" }, { id: 93, name: "Cremona" }, { id: 23, name: "Crotone" }, { id: 8, name: "Cuneo" }, { id: 15, name: "Enna" }, { id: 110, name: "Fermo" }, { id: 58, name: "Ferrara" }, { id: 49, name: "Firenze" }, { id: 31, name: "Foggia" }, { id: 59, name: "Forlì-Cesena" }, { id: 39, name: "Frosinone" }, { id: 82, name: "Genova" }, { id: 73, name: "Gorizia" }, { id: 50, name: "Grosseto" }, { id: 83, name: "Imperia" }, { id: 86, name: "Isernia" }, { id: 45, name: "L'Aquila" }, { id: 85, name: "La Spezia" }, { id: 40, name: "Latina" }, { id: 32, name: "Lecce" }, { id: 94, name: "Lecco" }, { id: 51, name: "Livorno" }, { id: 95, name: "Lodi" }, { id: 52, name: "Lucca" }, { id: 2, name: "Macerata" }, { id: 96, name: "Mantova" }, { id: 53, name: "Massa Carrara" }, { id: 27, name: "Matera" }, { id: 106, name: "Medio Campidano" }, { id: 16, name: "Messina" }, { id: 97, name: "Milano" }, { id: 60, name: "Modena" }, { id: 109, name: "Monza e Brianza" }, { id: 37, name: "Napoli" }, { id: 9, name: "Novara" }, { id: 79, name: "Nuoro" }, { id: 107, name: "Ogliastra" }, { id: 108, name: "Olbia Tempio" }, { id: 80, name: "Oristano" }, { id: 67, name: "Padova" }, { id: 17, name: "Palermo" }, { id: 61, name: "Parma" }, { id: 98, name: "Pavia" }, { id: 88, name: "Perugia" }, { id: 3, name: "Pesaro Urbino" }, { id: 46, name: "Pescara" }, { id: 62, name: "Piacenza" }, { id: 54, name: "Pisa" }, { id: 55, name: "Pistoia" }, { id: 74, name: "Pordenone" }, { id: 28, name: "Potenza" }, { id: 103, name: "Prato" }, { id: 18, name: "Ragusa" }, { id: 63, name: "Ravenna" }, { id: 24, name: "Reggio Calabria" }, { id: 64, name: "Reggio Emilia" }, { id: 41, name: "Rieti" }, { id: 65, name: "Rimini" }, { id: 42, name: "Roma" }, { id: 68, name: "Rovigo" }, { id: 38, name: "Salerno" }, { id: 81, name: "Sassari" }, { id: 84, name: "Savona" }, { id: 56, name: "Siena" }, { id: 19, name: "Siracusa" }, { id: 99, name: "Sondrio" }, { id: 33, name: "Taranto" }, { id: 47, name: "Teramo" }, { id: 89, name: "Terni" }, { id: 11, name: "Torino" }, { id: 20, name: "Trapani" }, { id: 101, name: "Trento" }, { id: 69, name: "Treviso" }, { id: 76, name: "Trieste" }, { id: 75, name: "Udine" }, { id: 100, name: "Varese" }, { id: 70, name: "Venezia" }, { id: 104, name: "Verbano Cusio Ossola" }, { id: 10, name: "Vercelli" }, { id: 71, name: "Verona" }, { id: 25, name: "Vibo Valentia" }, { id: 72, name: "Vicenza" }, { id: 43, name: "Viterbo" }]
    };
  },
  mounted() {
    this.setSource();
    Vue.nextTick(() => {
      $(this.$refs["modal"]).on('hidden.bs.modal', (event) => {
        this.error = null;
        this.success = false;

        Fandom.emit('contact-form-modal-hidden');
      })
    });
  },
  methods: {
    hideModal() {
      $(this.$refs["modal"]).modal("hide");
    },
    setSource() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const utm = params.get('utm');
      const ecmp = params.get('ecmp');

      if (!utm && !ecmp) {
        this.source = 'organic';
      } else {
        if (utm) {
          console.log(utm);
          this.source = `utm_${utm}`;
        }
        if (this.source != '') {
          console.log('|');
          this.source += '|';
        }
        if (ecmp) {
          console.log(ecmp);
          this.source += `ecmp_${ecmp}`;
        }
      }
    },
    submitForm() {
      const form = this.$refs["form"];
      this.error = null;
      if (form.checkValidity()) {
        const submitForm = (token) => {
          const data = {
              fields: {
                'partita_iva': this.fields.pIva,
                'ragioneSociale': this.fields.company,
                'provincia': this.fields.province,
                'nrCellulare': this.fields.telephone,
                'prodotto': this.productName,
                'source': this.source
              }
            }
          if (token)
            data.recaptcha_enterprise_token = token;

          Fandom.ajax({
            url: `/upload_contact_form`,
            method: "POST",
            data: data,
            success: (data) => {
              if (data.success) {
                this.fields = { pIva: '', company: '', province: '', telephone: '' };
                this.success = true;

                setTimeout(() => {
                  this.hideModal();
                }, 3000)
              } else {
                this.success = false;
                this.error = data.error;
              }
            }
          });
        };
        if (globalState.pageModel.aux.recaptcha_enterprise) {
          generateToken(submitForm, "submit");
        } else {
          submitForm();
        }
      } else {
        form.reportValidity();
      }
    }
  }
};
</script>

<template>
  <div id="modal-contact-form" ref="modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 pb-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center px-4 px-md-5 pb-5 pt-0 pt-md-4">
          <div class="mb-5">
            <h3 class="h4 font-weight-bold">{{ content.title }}</h3>
            <p>{{ content.subtitle }}</p>
            <p v-if="error" class="text-danger small font-weight-bold mt-4">{{ error }}</p>
          </div>
          <form ref="form">
            <div class="row">
              <div class="col-12 pb-4" v-if="success">
                <div class="alert alert-success" role="alert">
                  Dati salvati con successo.
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group text-left">
                  <label for="p-iva">Partita IVA *</label>
                  <input v-model="fields.pIva" type="text" class="form-control border-gray-900" id="p-iva" placeholder="P.IVA" pattern="\d{11}" required>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group text-left">
                  <label for="azienda">Azienda *</label>
                  <input v-model="fields.company" type="text" class="form-control border-gray-900" id="azienda" placeholder="Azienda" required>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group text-left">
                  <label for="provincia">Provincia *</label>
                  <select v-model="fields.province" class="form-control custom-select border-gray-900" id="provincia" required>
                    <option value="" selected disabled>Seleziona...</option>
                    <option v-for="province in provinces" :value="province.id">{{ province.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group text-left">
                  <label for="telefono">Numero di telefono *</label>
                  <input v-model="fields.telephone" type="text" class="form-control border-gray-900" id="telefono" placeholder="Numero di telefono" pattern="\+\d+|\d+" required>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <p class="small">* Tutti i campi sono obbligatori</p>
              <button type="button" class="btn shadow-none btn-primary mb-3" @click="submitForm()">{{ content.button_title }}</button>
              <p class="small" v-html="content.privacy"></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>